import { useCallback, useState } from "react";
import { t } from "../utils/translate.js";
export function useSsoLoginForm(api, config) {
    const [state, setState] = useState({
        email: config.initialEmail || '',
        errors: {},
        isLoading: false,
        aliases: []
    });
    const setEmail = useCallback((email)=>{
        setState((prev)=>({
                ...prev,
                email: email.trim(),
                errors: {
                    ...prev.errors,
                    email: undefined
                }
            }));
    }, []);
    const selectAlias = useCallback((alias)=>{
        config.onSsoRedirect(alias, state.email);
    }, [
        config,
        state.email
    ]);
    const submit = useCallback(async ()=>{
        const errors = {};
        if (!state.email) {
            errors.email = t(config, 'auth.error.requiredField');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
            errors.email = t(config, 'auth.error.invalidEmail');
        }
        if (errors.email) {
            setState((prev)=>({
                    ...prev,
                    errors
                }));
            return;
        }
        setState((prev)=>({
                ...prev,
                isLoading: true,
                errors: {},
                aliases: []
            }));
        try {
            const { aliases, error } = await api.getSsoAliases(state.email);
            if (error) {
                setState((prev)=>({
                        ...prev,
                        isLoading: false,
                        errors: {
                            form: t(config, 'auth.error.networkError')
                        }
                    }));
                return;
            }
            if (aliases.length === 0) {
                setState((prev)=>({
                        ...prev,
                        isLoading: false,
                        errors: {
                            form: t(config, 'auth.sso.notConfigured')
                        }
                    }));
            } else if (aliases.length === 1) {
                // Single alias — auto-redirect to IdP via the OIDC client
                config.onSsoRedirect(aliases[0].alias, state.email);
            } else {
                // Multiple aliases — show chooser
                setState((prev)=>({
                        ...prev,
                        isLoading: false,
                        aliases
                    }));
            }
        } catch  {
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    errors: {
                        form: t(config, 'auth.error.networkError')
                    }
                }));
        }
    }, [
        state.email,
        api,
        config
    ]);
    return {
        email: state.email,
        errors: state.errors,
        isLoading: state.isLoading,
        aliases: state.aliases,
        setEmail,
        submit,
        selectAlias
    };
}

//# sourceMappingURL=useSsoLoginForm.js.map